package devxertech.com.pages.industries.fintectIndustry.fintechSpotLight

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.css.TextAlign
import com.varabyte.kobweb.compose.css.TextTransform
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.flexWrap
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.theme.breakpoint.rememberBreakpoint
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import devxertech.com.component.FieldTitleTextNormalSimple
import devxertech.com.pages.commons.ManagementSoftwareNew
import devxertech.com.theme.toSitePalette
import devxertech.com.utils.Constants
import devxertech.com.utils.Res
import org.jetbrains.compose.web.css.FlexWrap
import org.jetbrains.compose.web.css.px

@Composable
fun FintechSpotLight() {
    val breakpoint = rememberBreakpoint()
    val sitePalette = ColorMode.current.toSitePalette()

    Box(
        modifier = Modifier
            .fillMaxWidth()
            .padding(top = if (breakpoint > Breakpoint.MD) 60.px else 45.px, bottom = 50.px),
        contentAlignment = Alignment.Center
    ) {
        Column(
            verticalArrangement = Arrangement.Center,
            horizontalAlignment = Alignment.CenterHorizontally
        ) {
            FieldTitleTextNormalSimple(
                "MORE BENEFITS OF OUR FINTECH SOFTWARE DEVELOPMENT SERVICES",
                color = sitePalette.commonSecondaryButtonColor.rgb,
                fontSize = if (breakpoint > Breakpoint.MD) 18.px else 16.px,
                textAlign = TextAlign.Center,
                paddingLeft = 10.px, paddingRight = 10.px
            )
            Row(
                modifier = Modifier.flexWrap(FlexWrap.Wrap).margin(top = 0.px),
                verticalAlignment = Alignment.CenterVertically,
                horizontalArrangement = Arrangement.Center
            ) {
                FieldTitleTextNormalSimple(
                    "Adaptability & ",
                    color = sitePalette.commonSecondaryButtonColor.rgb,
                    fontFamily = Constants.ROBOTO_FONT,
                    textTransform = TextTransform.Uppercase,
                    fontSize = if (breakpoint > Breakpoint.MD) 35.px else 22.px,
                    fontWeight = 700,
                    letterSpacing = 0.5.px
                )
                FieldTitleTextNormalSimple(
                    "Responsiveness",
                    color = sitePalette.primary.rgb,
                    fontFamily = Constants.ROBOTO_FONT,
                    textTransform = TextTransform.Uppercase,
                    fontSize = if (breakpoint > Breakpoint.MD) 35.px else 22.px,
                    fontWeight = 700,
                    letterSpacing = 0.5.px
                )
            }

            Row(
                modifier = Modifier
                    .fillMaxWidth()
                    .padding(top = if (breakpoint < Breakpoint.MD) 30.px else 50.px)
                    .margin(leftRight = 0.px).flexWrap(FlexWrap.Wrap),
                horizontalArrangement = Arrangement.Center
            ) {
                ManagementSoftwareNew(
                    image = Res.Image.fintech_soft_1,
                    imageWidth = 100.px,
                    imageHeight = 100.px,
                    sideImage = Res.Image.inovative_common,
                    title = "Enhanced Efficiency", marginChanges = true,
                    description = "Our advanced financial services increase efficiency, functionality and provide more " +
                            "avenues of innovative experimenting to deliver world class products.", paddingChanges = true
                )
                ManagementSoftwareNew(
                    image = Res.Image.fintech_soft_2,
                    imageWidth = 106.px,
                    imageHeight = 106.px,
                    sideImage = Res.Image.inovative_common,
                    title = "Lower costs",
                    description = "Our pricing policy is budget-friendly and is cost-effective in terms of hiring dedicated teams " +
                            "for the projects and consulting services.", paddingChanges = true)
                ManagementSoftwareNew(
                    image = Res.Image.fintech_soft_3,
                    imageWidth = 97.px,
                    imageHeight = 97.px,
                    sideImage = Res.Image.inovative_common,
                    title = "Flexibility and \n" +
                            "Personalization",
                    description = "Our engagement models are flexible and provide countless avenues for personalization and customization to give you the product " +
                            "that is aligned with your needs and the market."
                )
                ManagementSoftwareNew(
                    image = Res.Image.fintech_soft_4,
                    imageWidth = 93.px,
                    imageHeight = 93.px,
                    sideImage = Res.Image.inovative_common,
                    title = "Convenience of \n" +
                            "Transactions",
                    description = "Our financial management systems provide ease and convenience of transactions to ensure a " +
                            "balanced and smooth workflow."
                )
            }
        }
    }
}


